import { Component } from '@angular/core';

@Component({
	// tslint:disable-next-line
	selector: 'body',
	template: '<router-outlet></router-outlet>'
})
export class AppComponent {
  	constructor() {}
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts